export const LIST_LIST_INTERESTS_SUCCESS = "LIST_LIST_INTERESTS_SUCCESS";
export const LIST_LIST_INTERESTS_FAILURE = "LIST_LIST_INTERESTS_FAILURE";
export const LIST_INTERESTS_RESET = "LIST_INTERESTS_RESET";
export const ADD_LIST_INTEREST = "ADD_LIST_INTEREST";
export const REMOVE_NEW_LIST_INTEREST = "REMOVE_NEW_LIST_INTEREST";
export const DELETE_LIST_INTEREST = "DELETE_LIST_INTEREST";
